// extracted by mini-css-extract-plugin
module.exports = {"GlobalError":"GlobalError_GlobalError__ZOG7a","GlobalError__title":"GlobalError_GlobalError__title__lOD3L","GlobalError__info":"GlobalError_GlobalError__info___5MmL"};